module.exports = __webpack_public_path__ + "static/img/36.56930b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/36.png
// module id = 2aNb
// module chunks = 0